import {
  CHANGE_SORT,
  CHANGE_SORT_DIRECTION,
  type changeSortAction,
  type changeSortDirectionAction,
  SEARCH_SUCCESS,
  type searchSuccessAction,
  UPDATE_SEARCH_PARAMS_FROM_URL,
  type updateStateFromUrl,
} from "../actions";
import { SortDirection, type SortOption } from "~/features/search/models/models";

export interface SortState {
  selectedCode: string;
  selectedDirection: SortDirection | null;
  availableSorts: SortOption[];
}

export const sortInitialState: SortState = {
  selectedCode: "relevance",
  selectedDirection: null,
  availableSorts: [],
};

type SortActions =
  | ReturnType<typeof updateStateFromUrl>
  | ReturnType<typeof searchSuccessAction>
  | ReturnType<typeof changeSortDirectionAction>
  | ReturnType<typeof changeSortAction>;

export const sortReducer = (state = sortInitialState, action: SortActions): SortState => {
  switch (action.type) {
    case UPDATE_SEARCH_PARAMS_FROM_URL: {
      const params = action.payload;
      return {
        ...state,
        selectedCode: params.sortCode || "",
        selectedDirection: params.sortDirection,
      };
    }

    case SEARCH_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        availableSorts: data.sorts,
        selectedCode: data.selectedSort.code,
        selectedDirection: data.selectedSort.direction,
      };
    }

    case CHANGE_SORT_DIRECTION: {
      const direction = action.payload;
      return {
        ...state,
        selectedDirection: direction,
      };
    }

    case CHANGE_SORT: {
      const { sortCode, direction } = action.payload;

      const isAscdesc = state.availableSorts.find((item) => item.code === sortCode)?.isAscdesc ?? true;
      return {
        ...state,
        selectedCode: sortCode,
        selectedDirection: isAscdesc ? direction || SortDirection.ASC : null,
      };
    }

    default: {
      return state;
    }
  }
};
